import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=60518896&"
import script from "./Datenschutz.vue?vue&type=script&lang=js&"
export * from "./Datenschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../usr/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports